import { z } from 'zod';

/**
 * Public auth configuration exposed by `GET /auth/config`.
 *
 * The platform's current Terms-of-Service + Privacy-Policy version strings.
 * Clients (portal + mobile) fetch these at signup / invite-accept time and echo
 * them back so the API's exact-match consent guard
 * (`termsAcceptedVersion === env.TERMS_OF_SERVICE_VERSION`) passes regardless of
 * how the server-side versions change over time. This makes the API env the
 * single source of truth and removes the historical drift where clients
 * hard-coded a stale version literal.
 */
export interface AuthConfig {
  readonly termsVersion: string;
  readonly privacyVersion: string;
  /**
   * Platform switches clients use to show/hide optional surfaces. `whatsapp`
   * is false until WhatsApp delivery is activated (docs/WHATSAPP_SETUP.md);
   * while false, apps hide every WhatsApp opt-in and phone-number invites.
   */
  readonly features?: { readonly whatsapp: boolean };
}

export const AuthConfigSchema = z.object({
  termsVersion: z.string().min(1),
  privacyVersion: z.string().min(1),
  features: z.object({ whatsapp: z.boolean() }).optional(),
});
